import { createSelector } from '@reduxjs/toolkit';

import { fetchUserIfNeeded } from '@lootboy/lib/actions/UserActions';
import { authSelector } from '@lootboy/lib/selectors';
import { fetchRadarUserDataIfNeeded } from '@lootboy/lib/slices/radarUserProfile';

import { observeStore } from '~/redux/obesrvers/observeStore';

const select = createSelector(authSelector, ({ token }) => token);

const onChange = (token, dispatch) => {
  if (token) {
    dispatch(fetchUserIfNeeded()).catch(() => {});
    dispatch(fetchRadarUserDataIfNeeded()).catch(() => {});
  }
};

export default (store) => observeStore(store, select, onChange);
